import React, { useMemo } from 'react';
import { useAITTheme, type AITTheme } from '@this/shared/ui/theme';
import { Datepicker } from '@this/shared/ui/inputs/datepicker';
import { Input } from '@this/shared/ui/inputs/input';

interface Props {
  hotelCheckinDate: Date | null;
  hotelCheckoutDate: Date | null;
  hotelArea: string;
  onHotelCheckinDateChange: (date: Date | null) => void;
  onHotelCheckoutDateChange: (date: Date | null) => void;
  onHotelAreaChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const TemplateAssistantHotelOnlyFields = ({
  hotelCheckinDate,
  hotelCheckoutDate,
  hotelArea,
  onHotelCheckinDateChange,
  onHotelCheckoutDateChange,
  onHotelAreaChange
}: Props) => {
  const { theme } = useAITTheme();
  const styles = useMemo(() => getStyles(theme), [theme]);

  return (
    <>
      <div style={styles.formGroup}>
        <label style={styles.label}>チェックイン日</label>
        <Datepicker
          type="date"
          aria-label="チェックイン日入力"
          value={hotelCheckinDate ?? undefined}
          onChange={onHotelCheckinDateChange}
          min={new Date()}
          dateFormat="YYYY/MM/DD (ddd)"
          disabledClear
        />
      </div>

      <div style={styles.formGroup}>
        <label style={styles.label}>チェックアウト日</label>
        <Datepicker
          type="date"
          aria-label="チェックアウト日入力"
          value={hotelCheckoutDate ?? undefined}
          onChange={onHotelCheckoutDateChange}
          min={hotelCheckinDate ?? new Date()}
          dateFormat="YYYY/MM/DD (ddd)"
          disabledClear
        />
      </div>

      <div style={styles.formGroup}>
        <label style={styles.label}>ホテルの希望エリア</label>
        <Input value={hotelArea} onChange={onHotelAreaChange} placeholder="駅名 / エリア名など" fullWidth />
      </div>
    </>
  );
};

const getStyles = (theme: AITTheme) => ({
  formGroup: {
    display: 'flex',
    flexDirection: 'column' as const,
    gap: '8px'
  },
  label: {
    fontSize: '14px',
    fontWeight: 600 as const,
    color: theme.textColor
  }
});

export default TemplateAssistantHotelOnlyFields;
